import { useSelector } from "react-redux";
import classNames from "classnames";

import { useRoutesContext } from "../Routes/RoutesContext";
import HeadTitle from "./HeadTitle";
import ShareButtons from "../ShareButtons";
import Subscription from "../Subscriptions/Subscription";
import TaxonomyIcons from "../Taxonomies/TaxonomyIcons";
import Breadcrumbs from "./Breadcrumbs";

const PageTitle = ({
  shareButtons = true,
  subscribable = true,
  breadcrumbs = true,
  includePlatformTitleInHeadTitle = true,
  childrenPosition = "after",
  ...props
}) => {
  const { title, page, children, sticky } = props;
  const { pathFor } = useRoutesContext();
  const socialSharingEnabled = useSelector(({ styling }) => styling.socialSharingEnabled);
  // const isPageScrolled = useSelector(({ styling }) => styling.isPageScrolled);
  const homePath = pathFor("home");
  // Direct home children have a short breadcrumb path. Keep it expanded even with a
  // sticky action bar so the explicit home label remains visible above the title.
  const isDirectHomeChild =
    page?.ancestors?.length === 1 && page.ancestors[0]?.resourcePath === homePath;
  const isCollapsed = sticky && !isDirectHomeChild; // && isPageScrolled;

  const taxonomies = page?.taxonomies;

  const displayShareButtons = shareButtons && socialSharingEnabled;
  const displayBreadcrumbs = page && breadcrumbs;

  const displayChildrenAfterTitle = childrenPosition === "after";

  const className = classNames(
    "box",
    "box-page-title",
    "page-header-content",
    props.className,
    { "with-share-buttons": displayShareButtons }
  );

  const titleContainerClassName = classNames(
    "flex-1",
    "box-page-title-content",
    props.titleContainerClassName,
    {
      "d-flex": isCollapsed,
      "align-items-center": isCollapsed
    }
  );

  const titleClassName = classNames("text-title-page", {
    "text-title-page-sm": isCollapsed
  });

  const breadcrumbsClassName = classNames({
    "margin-bottom-xs": !isCollapsed,
    "d-flex": !isCollapsed,
    "float-left": isCollapsed,
    "margin-right-xs": isCollapsed
  });

  const shareButtonsClassName = classNames({
    "margin-left-xs": subscribable
  });

  return (
    <>
      <HeadTitle title={title} includePlatformTitle={includePlatformTitleInHeadTitle} />

      <div className={className}>
        <div className="box-page-title-inner d-flex align-items-center">
          <div className={titleContainerClassName}>
            {displayBreadcrumbs && (
              <Breadcrumbs
                page={page}
                className={breadcrumbsClassName}
                onlyShowArrow={isCollapsed}
              />
            )}

            {!displayChildrenAfterTitle && children}

            <h1 className={titleClassName}>{title}</h1>

            {/*
             * The children prop is used to add additional content inside the main title
             * container
             */}
            {displayChildrenAfterTitle && children}
          </div>

          {subscribable && <Subscription subscribable={page} hideLabel />}

          {displayShareButtons && <ShareButtons className={shareButtonsClassName} />}

          {/*
           * The null is passed for now while the taxonomies aren't set in all
           * components that use the PageTitle component.
           */}
          {taxonomies && <TaxonomyIcons taxonomies={taxonomies} />}
        </div>
      </div>
    </>
  );
};

export default PageTitle;
